import type { BuffChargeState } from '@/modules/game-domain/hero.types';

/** An elapsed window allows the server to perform its authoritative refill on activation. */
export function isBuffQuotaExhausted(charge: BuffChargeState | undefined, nowMs: number): boolean {
  if (charge == null || charge.remaining > 0) return false;
  const periodEndMs = charge.periodEnd ? Date.parse(charge.periodEnd) : NaN;
  return !Number.isFinite(periodEndMs) || nowMs < periodEndMs;
}
